import {
  UPDATE_TRANSLATION,
  SET_MODIFIED_TRANSLATIONS,
  ADD_FAQ_ROW
} from '../actionTypes'
import produce from 'immer'
import { set } from 'lodash'

export default function admin(
  state = {
    modifiedTranslations: null
  },
  action
) {
  switch (action.type) {
    case ADD_FAQ_ROW:
      return produce(state, draft => {
        const bundle = draft.modifiedTranslations || {}
        const langs = Object.keys(bundle).filter(
          key =>
            key !== 'expires' &&
            key !== 'errors' &&
            bundle[key] != null &&
            typeof bundle[key] === 'object' &&
            !Array.isArray(bundle[key])
        )

        let faqAmount = 0
        langs.forEach(lang => {
          const faq = bundle[lang] && bundle[lang].faq
          if (!faq || typeof faq !== 'object') return
          Object.keys(faq).forEach(entry => {
            const number = parseInt(entry.split('_')[1], 10)
            if (number) faqAmount = Math.max(faqAmount, number)
          })
        })

        const nextFaqIndex = faqAmount + 1
        langs.forEach(lang => {
          if (!bundle[lang].faq || typeof bundle[lang].faq !== 'object') {
            bundle[lang].faq = {}
          }
          bundle[lang].faq['q_' + nextFaqIndex] = ''
          bundle[lang].faq['a_' + nextFaqIndex] = ''
        })
      })
    case SET_MODIFIED_TRANSLATIONS:
      return {
        ...state,
        modifiedTranslations: action.translations
      }
    case UPDATE_TRANSLATION: {
      const { lang, topic, key, value, path } = action

      return produce(state, draft => {
        let target = draft.modifiedTranslations[lang]
        if (target?.[topic]?.[key]) {
          if (path.length) {
            path.forEach(p => {
              target = target[p]
            })
          }
          target[topic][key] = value
        } else {
          let pathString = ''
          if (path.length) {
            path.forEach(p => {
              pathString += `${p}.`
            })
          }
          set(draft.modifiedTranslations[lang], `${pathString}${topic}.${key}`, value)
        }
      })
    }
    default:
      return state
  }
}
